import _sfc_main from "./component-library118.mjs";
import "./component-library119.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("label", { staticClass: "toggle", class: _setup.containerClass }, [_c("input", { staticClass: "toggle__checkbox", attrs: { "role": "switch", "type": "checkbox", "tabindex": "0", "aria-label": _vm.ariaLabel }, domProps: { "checked": _vm.value }, on: { "change": _setup.change } }), _c("span", { staticClass: "toggle__controls btn btn--default", class: _setup.controlsClasses }, [_c("span", { staticClass: "toggle__bullet" })]), _c("span", { staticClass: "toggle__label" }, [_vm._t("default", function() {
    return [_c("span", { domProps: { "innerHTML": _vm._s(_vm.label) } })];
  })], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ba1ced77",
  null,
  null
);
const toggle = __component__.exports;
export {
  toggle as default
};
